import React, { createContext, useEffect, useState } from 'react';

import { useZones } from 'pages/zones/zones.hook';
import { useFetchBuildingQuery } from 'store/apis';
import { useAppSelector } from 'store/store.hook';
import { selectCurrentUserInfo } from 'store/slices/auth.slice';
import { initVisualization } from 'utils';

export type Visualization = ReturnType<typeof initVisualization>;

type VisualizationContext = {
  buildingId: number;
  loading_visualization: boolean;
  visualization: Visualization;
};

const defaultVisualizationContextValue = {
  buildingId: 0,
  loading_visualization: false,
  visualization: null,
};

export const VisualizationContext = createContext<VisualizationContext>(defaultVisualizationContextValue);

interface VisualizationProviderProps {
  children?: any;
  buildingId: number;
}

export const VisualizationProvider = ({ children, buildingId }: VisualizationProviderProps) => {
  const [loading_visualization, setLoadingVisualization] = useState<boolean>(false);
  const { orgSlug } = useAppSelector(selectCurrentUserInfo);
  const { data: building, isLoading: loading_building } = useFetchBuildingQuery({ orgSlug, id: buildingId as number });
  const [loading_zones, { all: buildingZones }] = useZones({ buildingId });

  const visualization = initVisualization({ building, zones: buildingZones });

  useEffect(() => {
    if (!loading_building && !loading_zones && building && buildingZones) {
      setLoadingVisualization(false);
    } else {
      setLoadingVisualization(true);
    }
  }, [loading_building, loading_zones, building, buildingZones]);

  return (
    <VisualizationContext.Provider
      value={{
        buildingId,
        loading_visualization,
        visualization,
      }}
    >
      {children}
    </VisualizationContext.Provider>
  );
};
